export const ADMIN_PANEL_PATHS = {
  PRODUCTION_UNIT_TYPES: 'production-unit-types',
  PRODUCTION_UNIT_LABELS: 'production-unit-labels',
  ORDER_LABELS: 'order-labels',
  PRODUCTION_UNITS: 'production-units',
  OPERATOR_TYPES: 'operator-types',
  GARMENT_FAMILIES: 'garment-families',
  FILE_CATEGORIES: 'file-categories',
  GARMENT_NODES: 'garment-nodes',
  SEASONS: 'seasons',
  MACHINE_TYPES: 'machine-types',
  SIZE_STANDARDS: 'size-standards',
  CLIENTS: 'clients',
  PRODUCER: 'producers',
  BASE_PROCESSES: 'base-processes',
  OPERATORS: 'operators',
  RATES: 'rates',
  ORDER_VARIANT_ATTRIBUTES: 'variant-attributes',
  CUTTING_MATERIAL_TYPE: 'cutting-material-type',
  TEAMS: 'teams',
  BUNDLE_TEMPLATES: 'bundle-templates',
  CALENDARS: 'calendars',
  SHOP_FLOOR_TEMPLATES: 'shop-floor-templates',
  DEFECT_SEVERITIES: 'defect-severities',
  DEFECT_CATEGORIES: 'defect-categories',
  DEFECT_TYPES: 'defect-types'
}
